import { EmployeeReportState } from '../interface/EmployeeReportInterface'
import { push } from 'connected-react-router'
import { LinkStuff } from '../interface/MyInterfaces'
import { handleReportDisplayIdChange_EmployeeReport, authenticateUserOutsideLogin } from './UserActions';
import { authHeader } from '../javascript/auth-header';
import {
    numberWithCommas, inWords_ThreeYears, getTotalEmployees, getSectorCount, getSectorWage, isAgg, numberFormat, numberRound, capitalize
} from '../components/Common/Helpers';

export function downloadReport(EmployeeReportState) {

}

export function openZoomed(chart_no) {
    return {
        type: "OPEN_ZOOM",
        payload: chart_no
    }
}

export function closeZoomed() {
    return {
        type: "CLOSE_ZOOM",
        payload: 0
    }
}

export function loadEmployeeReport(display_id, vintage) {

    return dispatch => {
        let x: EmployeeReportState = {
            showZoomed: 0, EmployeeReport_Tab1: { bullets: "" }, EmployeeReport_Tab2: { bullets: "" }, EmployeeReport_MatchRateTab: { bullets: "" }
        };
        dispatch({
            type: "EMPLOYEE_REPORT_LOADING",
            payload: x
        })
        dispatch(loadEmployeeProfileInfo(display_id, vintage));
    }
}

export function loadEmployeeSharedReport(link_id, p1, p2) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SharedLink/report_link/" + link_id + "/" + p1 + "/" + p2;
        var headers = authHeader();
        fetch(url, {
            method: 'GET',
            headers: headers
        })
            .then(function (response) {
                return response.json();
            })
            .then(async function (json) {
                var link: LinkStuff = json;
                if (link.link_id == -1) {

                    dispatch({
                        type: "BAD_LINK",
                        payload: json
                    });
                    dispatch(push('/reports/bad_link'));
                } else {
                    await authenticateUserOutsideLogin();
                    dispatch(loadEmployeeReport(link.display_id, link.vintage));
                    dispatch(handleReportDisplayIdChange_EmployeeReport(
                        { value: link.display_id }));
                }
            });
    };
}



export function loadMatchRate(display_id, vintage, EmployeeProfileInfo) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/EmployeeReport/match_report_data/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "EMPLOYEE_MATCH_RATE",
                    payload: json[0]
                })
                dispatch(setMatchRateBullets(json[0], EmployeeProfileInfo));
            });
    };
}
export function loadEmployeeProfileInfo(display_id, vintage) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/EmployeeReport/profile_info/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "EMPLOYEE_PROFILE_INFO",
                    payload: json[0]
                })
                dispatch(loadEmployeeProfile1(display_id, vintage, json[0]));
                dispatch(loadEmployeeProfile2(display_id, vintage, json[0]));
                dispatch(loadMatchRate(display_id, vintage, json[0]));
            });
    };
}





export function setTab2_bullets(year, type, EmployeeProfile2, EmployeeProfileInfo, display_id) {
    return dispatch => {
        //var min_year = EmployeeProfile2 && Math.min.apply(Math, [...new Set(EmployeeProfile2.map(x => x.year))]);
        //var max_year = EmployeeProfile2 && Math.max.apply(Math, [...new Set(EmployeeProfile2.map(x => x.year))]);

        const employeeUni = EmployeeProfileInfo.university;
        const selectedYear = year;
        const selectedEmployeeType = type;
        let employeeType;

        selectedEmployeeType === "Graduate Student"
            ? employeeType = "graduate students"
            : selectedEmployeeType === "Postdoctoral"
                ? employeeType = "post docs"
                : selectedEmployeeType === "All" ?
                    employeeType = "employees" : employeeType = "other employees";

        const totalAllEmployees = getTotalEmployees(EmployeeProfile2, "All", selectedYear);
        const totalOtherEmployees = getTotalEmployees(EmployeeProfile2, "Other", selectedYear);
        const totalGradStudent = getTotalEmployees(EmployeeProfile2, "Graduate Student", selectedYear);
        const totalPostDoc = getTotalEmployees(EmployeeProfile2, "Postdoctoral", selectedYear);
        const agg = isAgg(display_id);

        const totalEmployees = selectedEmployeeType == "Graduate Student" ? totalGradStudent : selectedEmployeeType == "Postdoctoral" ? totalPostDoc : selectedEmployeeType == "All" ? totalAllEmployees : totalOtherEmployees;

        const countPrivate = getSectorCount(EmployeeProfile2, selectedEmployeeType, selectedYear, "Private");
        const wagePrivate = getSectorWage(EmployeeProfile2, selectedEmployeeType, selectedYear, "Private");

        const countEducation = getSectorCount(EmployeeProfile2,
            selectedEmployeeType,
            selectedYear,
            "Education");

        const wageEducation = getSectorWage(EmployeeProfile2,
            selectedEmployeeType,
            selectedYear,
            "Education");
        var bullets = `<p>${inWords_ThreeYears(selectedYear) && inWords_ThreeYears(selectedYear).charAt(0).toUpperCase() + inWords_ThreeYears(selectedYear).slice(1)}years after leaving ${agg ? `their home institutions` : employeeUni}, we found:</p>`;
        var bullet1 = `<li>an average of approximately <b>${numberRound(totalEmployees,2)}</b> research-trained ${employeeType} employed across the U.S.</li>`;
        var bullet2 = getSectorEmploymentText_Copy(selectedYear, employeeType, "private", countPrivate, wagePrivate, employeeUni, agg);
        var bullet3 = getSectorEmploymentText_Copy(selectedYear, employeeType, "education", countEducation, wageEducation, employeeUni, agg);
        if (totalEmployees == 0)
            bullets = ""
        else {
            bullets += `<p><ul>${bullet1}${(bullet2 == undefined) ? "" : bullet2}${(bullet3 == undefined) ? "" : bullet3}</ul></p>`;
            bullets += `<p>

NOTE: The number of employees shown in the later cohorts may be lower than in earlier cohorts because of the the limited number of years of wage data available to form the final cohorts.</p>`;
        }
        dispatch({
            type: "EMPLOYEE_TAB2_BULLETS",
            payload: { bullets }
        });
    }
}

function getSectorEmploymentText_Copy(selectedYear, employeeType, sectorType, sectorCount, sectorWage, employeeUni, agg) {
    if (sectorCount > 0 && sectorWage > 0) {
        return (
            `<li>an average of approximately <b>${numberRound(sectorCount, 2)}</b> research-trained ${employeeType} could be found working in the ${sectorType} sector and earning an average of <b> ${numberFormat(sectorWage)}</b> annually.</li>`
        )
    }
}



function getDefaultType_Copy(empProfile) {
    const allSum = empProfile.filter(d => d.employee === 'All').reduce((acc, cur) => acc += cur.count, 0);
    const postDocSum = empProfile.filter(d => d.employee === 'Postdoctoral').reduce((acc, cur) => acc += cur.count, 0);
    const gradStudentSum = empProfile.filter(d => d.employee === 'Graduate Student').reduce((acc, cur) => acc += cur.count, 0);
    if (allSum > 0) return "All";
    return (allSum === 0 && postDocSum === 0 && gradStudentSum === 0) ? 'Other' : 'Graduate Student';
}

function setTab2(EmployeeProfile2, EmployeeProfileInfo,displayId) {
    return dispatch => {
        var min_year = EmployeeProfile2 && Math.min.apply(Math, [...new Set(EmployeeProfile2.map(x => x.year))]);
        var max_year = EmployeeProfile2 && Math.max.apply(Math, [...new Set(EmployeeProfile2.map(x => x.year))]);
        dispatch(setTab2_bullets(1, getDefaultType_Copy(EmployeeProfile2), EmployeeProfile2, EmployeeProfileInfo, displayId));

        dispatch({
            type: "EMPLOYEE_TAB2",
            payload: { min_year: min_year, max_year: max_year }
        });
    }
}


function setBullets(EmployeeProfileInfo, EmployeeProfile1) {
    return dispatch => {
        var total_employees = EmployeeProfileInfo.employees;
        var total_states = EmployeeProfile1.filter(x => x.count > 0 && x.fips != 11).length;
        var columbia = (EmployeeProfile1.filter(x => x.fips == 11).length == 1) ? "and the District of Columbia" : "";
        var start_year = EmployeeProfileInfo.year_first_left;
        var end_year = EmployeeProfileInfo.year_last_left;
        var isState = EmployeeProfile1.filter(x => x.fips == EmployeeProfileInfo.state_fips).length > 0;
        if (isState) {
            var percent = EmployeeProfile1.filter(x => x.fips == EmployeeProfileInfo.state_fips)[0].per * 100;
        }
        var home_state = EmployeeProfileInfo.state;

        var bullets = `<ul><li>Roughly <b>${numberRound(total_employees,2)}</b> research-trained employees at ${EmployeeProfileInfo.university} found subsequent employment in <b>${total_states} states ${columbia}</b> between <b>${start_year}</b> and <b>2017 (the most recent year available through federal data)</b>.</li>`
        var destination_counts = [];

        EmployeeProfile1.map(x => {
            var value;
            if (x.count <= 14) {
                value = "<15";
            }
            else {
                value = numberWithCommas(x.count);
            }
            destination_counts.push({ value: value, label: x.state });
        })
        if (isState) {
        var in_state_count = `# of Employees staying in-state: ${numberWithCommas(EmployeeProfile1.filter(x => x.fips == EmployeeProfileInfo.state_fips)[0].count)}`; 
            bullets += `<li>Approximately <b>${percent.toFixed(0)}%</b> of these research-trained employees at ${EmployeeProfileInfo.university} found employment in the state of ${home_state}.</li>`;
        }
        bullets += `</ul>`;
        dispatch({
            type: "EMPLOYEE_TAB1_BULLETS",
            payload: { bullets: bullets, destination_counts: destination_counts, in_state_count: in_state_count, year_first_left: start_year }
        });
    }
}

function setMatchRateBullets(EmployeeMatchRate, EmployeeProfileInfo) {
    return dispatch => {

        var bullets = `<ol><li>Assigning a Census Protected Identification Key (PIK): Census Bureau data uses a unique individual identifier called the PIK. The matching process uses name, month and year of birth to identify unique PIKs for individuals employed in research on your campus. <span className="red">${capitalize(EmployeeProfileInfo.the_university)}'s PIK rate was ${EmployeeMatchRate && EmployeeMatchRate.pik_pct}%</span>.</li>
                    <li>Identifying "Leavers": The report we shared with you is based on earnings information for research employees who left your institution. In our process an individual's last year at a university is the last year they receive a W2 from the institution or the last year they appear on a UMETRICS	grant. <span className="red">Of the employee names submitted by ${EmployeeProfileInfo.the_university} and matched to Census PIKs, ${EmployeeMatchRate.leave_pct}% left the university</span>.</li>
                    <li>Collecting Earnings Data: Earnings data reported here are based on W2 information for leavers. In cases where an individual departs in 2017 or later, we cannot determine their earnings because the most recent year of earnings data available is 2017. Census is currently updating their W2 data to include 2017 information to account for this issue. <span className="red">${numberWithCommas(EmployeeMatchRate.leavers_w2earnings)} (${EmployeeMatchRate.wage_pct}%) of ${EmployeeProfileInfo.the_university} "leavers" have W2 earnings information. We are working with Census to identify means to improve this match rate</span>.</li></ol>`;
        dispatch({
            type: "EMPLOYEE_TAB_MATCHRATE",
            payload: { bullets: bullets }
        });
    }
}

export function loadEmployeeProfile1(display_id, vintage, EmployeeProfileInfo) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/EmployeeReport/profile_1/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {

                dispatch({
                    type: "EMPLOYEE_PROFILE_1",
                    payload: json
                })
                dispatch(setBullets(EmployeeProfileInfo, json));
            });
    };
}
export function loadEmployeeProfile2(display_id, vintage, EmployeeProfileInfo) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/EmployeeReport/profile_2/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {

                dispatch({
                    type: "EMPLOYEE_PROFILE_2",
                    payload: json
                })
                dispatch(setTab2(json, EmployeeProfileInfo, display_id))
            });
    };
}



export function downloadEmployeeDataFiles(display_id, vintage) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/EmployeeReport/download_employee_data/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.text();
            })
            .then(function (text) {
                const downloadDataFileHref = "data: application/vnd.ms-excel;" + "base64," + text;
                dispatch({
                    type: "DOWNLOAD_DATA_FILES",
                    payload: downloadDataFileHref
                })
            });
    };
}